<template>
  <div class="page-container">
    <div
      class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 p-4 shadow-sm h-md-250 position-relative"
    >
      <b-form @submit.prevent="onSubmit" class="col-12">
        <h5>
          Dane osobowe administratora
          <hr />
        </h5>
        <div class="row">
          <b-form-group
            id="input-group-name"
            label="Imię:"
            label-for="input-name"
            description=""
            class="col-5"
          >
            <b-form-input
              id="input-name"
              v-model="form.name"
              type="text"
              required
              placeholder="Wpisz imię administratora"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-lastname"
            label="Nazwisko:"
            label-for="input-lastname"
            description=""
            class="col-5"
          >
            <b-form-input
              id="input-lastname"
              v-model="form.lastname"
              type="text"
              required
              placeholder="Wpisz nazwisko administratora"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-email"
            label="Adres email:"
            label-for="input-email"
            description=""
            class="col-4"
          >
            <b-form-input
              id="input-email"
              v-model="form.email"
              type="email"
              required
              disabled
              placeholder="Wpisz adres email administratora"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-phone"
            label="Numer telefonu:"
            label-for="input-phone"
            description="Pole nieobowiązkowe"
            class="col-4"
          >
            <b-form-input
              id="input-phone"
              v-model="form.phone"
              type="text"
              placeholder="Wpisz numer telefonu administratora"
              v-mask="'48 ### ### ###'"
            ></b-form-input>
          </b-form-group>

          <h5 class="col-12 mt-2">
            Typ konta
            <hr />
          </h5>
          <b-form-group
            v-if="isSuperAdmin"
            id="input-group-account-type"
            label-for="account-type"
            description=""
            class="col-6"
          >
            <b-form-select
              id="account-type"
              v-model="form.account_type"
              :options="accountTypes"
              required
              change="onChangeAccountType"
            ></b-form-select>
          </b-form-group>
          <template v-if="form.account_type === 'admin'">
            <h5 class="col-12 mt-2">
              Lokalizacje
              <hr />
            </h5>
            <b-form-group
              id="input-group-api_key"
              label="Lokalizacje, do których dostęp będzie miał administrator:"
              label-for="input-localizations"
              :description="localizations"
              class="col-12"
            >
              <tags-input
                input-id="input-localizations"
                v-model="form.api_keys"
                :existing-tags="allowedApiKeys"
                :typeahead="true"
                :typeahead-hide-discard="true"
                placeholder="Wpisz nazwę lokalizacji"
                :only-existing-tags="onlyExistingTags"
                :limit="limit"
              >
              </tags-input>
            </b-form-group>
          </template>
          <div class="col-12 row">
            <div class="col-12">
              <b-form-group v-if="isSuperAdmin">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="form.blocked"
                  name="checkbox-1"
                  value="true"
                  unchecked-value="false"
                >
                  Konto zablokowane
                </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col-12">
              <b-button type="submit" variant="primary">Zapisz administratora</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddAdministrator',
  async created() {
    const vm = this
    await vm.fetchLocalizations()
    await vm.fetchAdminData()
  },
  mounted() {
    const vm = this
    vm.user_account_type = localStorage.getItem('account_type')
    if (this.user_account_type === 'super_admin') {
      vm.accountTypes = [
        { text: 'Administrator', value: 'admin' },
        { text: 'Super administrator', value: 'super_admin' }
      ]
    }
  },
  data() {
    return {
      form: {
        account_type: 'admin',
        name: '',
        lastname: '',
        email: '',
        phone: '',
        api_keys: [],
        blocked: false
      },
      accountTypes: [{ text: 'Administrator', value: 'admin' }],
      allowedApiKeys: [],
      onlyExistingTags: true,
      limit: 0,
      localizations: 'Dostępne do wyboru: ',
      user_account_type: ''
    }
  },
  computed: {
    isSuperAdmin() {
      return this.user_account_type === 'super_admin'
    }
  },
  methods: {
    async fetchAdminData() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'fetchAdminData')
      try {
        const response = await vm.$http.get(`e-zacma/admin/${vm.$route.params.id}`)
        vm.form.name = response.data.name
        vm.form.lastname = response.data.lastname
        vm.form.email = response.data.email
        vm.form.phone = response.data.phone
        vm.form.account_type = response.data.account_type
        vm.form.blocked = response.data.blocked === 1
        vm.form.api_keys = JSON.parse(response.data.api_keys).map(key => ({
          key,
          value: vm.allowedApiKeys.find(allowedKey => allowedKey.key === key).value
        }))
      } catch (e) {
        vm.$error()
      } finally {
        vm.$store.commit('removePageLoaderEvent', 'fetchAdminData')
      }
    },
    onSubmit() {
      const vm = this

      if (
        vm.form.account_type === 'admin' &&
        (typeof vm.form.api_keys === 'undefined' ||
          vm.form.api_keys === '' ||
          vm.form.api_keys.length === 0)
      ) {
        vm.$error('Należy podać lokalizacje.')
        return
      }

      vm.$store.commit('addPageLoaderEvent', 'createAdmin')
      const fromData = { ...vm.form, api_keys: vm.form.api_keys.map(item => item.key) }
      vm.$http
        .put(`e-zacma/admin/${vm.$route.params.id}`, fromData)
        .then(() => {
          vm.$router.push({ name: 'users' }) && vm.$success('Administrator edytowany')
        })
        .catch(error => {
          const { data } = error.response
          if (
            data &&
            data.errors &&
            data.errors.email &&
            data.errors.email[0] === 'The email has already been taken.'
          ) {
            vm.$error('Nie można utworzyć konta na podany adres email')
          } else if (
            data &&
            data.status &&
            data.message &&
            data.status === 422 &&
            data.message === 'Api keys are not in same scope'
          ) {
            vm.$error(
              'Podane lokalizacje nie znajdują się w tej samej organizacji! Zmień lokalizacje i spróbuj ponownie!',
              'Nie można zapisać administratora'
            )
          } else {
            vm.$error()
          }
          vm.error()
        })
        .finally(() => {
          vm.$store.commit('removePageLoaderEvent', 'createAdmin')
        })
    },
    fetchLocalizations() {
      const vm = this
      return vm.$http.post('e-zacma/get-allowed-api-keys').then(response => {
        const allowedLocalizations = response.data
        let i = 0
        // eslint-disable-next-line no-restricted-syntax
        for (const localization of allowedLocalizations) {
          // eslint-disable-next-line no-plusplus
          ++i
          vm.allowedApiKeys.push({ key: localization.api_key, value: localization.name })
          vm.localizations +=
            allowedLocalizations.length > i ? `${localization.name}, ` : localization.name
        }
        vm.limit = i
      })
    }
  }
}
</script>

<style scoped></style>
